export default {
    siteinfo: {
        'uniacid': '1',
        'siteroot': 'https://farmdev.farmkd.com/index.php',
        // 'siteroot': 'http://192.168.100.6/index.php',
        // 'siteroot': 'http://farm.test.farmkd.com/index.php'
        // 'siteroot': 'https://farm.jswxpdd.com/index.php',
        // 'siteroot': 'https://farm.wisfood.com/index.php'
    }
}



// WEBPACK FOOTER //
// ./src/util/siteinfo.js